define([
	"dojo/_base/declare",
	"Sourcing/NewProductAlternativeBase",

	"Sourcing/ProductAlternativeForm2"
], function(declare,NewProductAlternativeBase) {

	return declare(NewProductAlternativeBase, {
		_getSpecURL: function() {
			const themePA = this.m_cache.getNode(this.m_formData.getFieldValue("ThemePA"));
			return themePA ? themePA.ThemePASpec : null;
		},

		_getThemePaURL: function() {
			return this.m_formData.getFieldValue("ThemePA");
		}
	});
});